/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_SubmitInputs */

const en_business_form_submit = /** @type {(inputs: Business_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Sales`)
};

const es_business_form_submit = /** @type {(inputs: Business_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactar ventas`)
};

/**
* | output |
* | --- |
* | "Contact Sales" |
*
* @param {Business_Form_SubmitInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_submit = /** @type {((inputs?: Business_Form_SubmitInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_SubmitInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_submit(inputs)
	return en_business_form_submit(inputs)
});